export const WA_NUMBER = "916399333394";
export const PHONE_DISPLAY = "+91 63993 33394";
export const EMAIL = "spvh.vrindavan@gmail.com";
export const ADDRESS =
  "100 Futa Road, Near Flyover, Chaitanya Vihar, Vrindavan, Dist. Mathura, Uttar Pradesh 281121";
export const GSTIN = "09KRHPS00066N1ZY";
export const GBP_URL = "https://share.google/0DedCkd64iLSeIbh4";
export const MAPS_URL = "https://maps.google.com/?cid=16140406779635432743";
export const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=Shri%20Jamuna%20Dham%2C%20100%20Futa%20Road%2C%20Chaitanya%20Vihar%2C%20Vrindavan%2C%20Uttar%20Pradesh%20281121";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const ROOMS = [
  {
    id: "nidhivan-deluxe",
    name: "Nidhivan Deluxe",
    type: "Deluxe Room",
    hindi: "निधिवन",
    capacity: "2 Adults",
    beds: "1 King Size Bed / 2 Single Beds",
    image: "/images/rooms/deluxe.jpg",
    features: ["Air Conditioning", "Smart TV", "Geyser", "Western Toilet", "Room Service"],
    blurb:
      "A calm, cool retreat for two — crisp linen, warm wood and everything you need after evening darshan.",
  },
  {
    id: "seva-kunj-triple",
    name: "Seva Kunj Triple",
    type: "3 Bed Deluxe Room",
    hindi: "सेवा कुंज",
    capacity: "3 Adults",
    beds: "3 Single Beds / 1 King + 1 Single",
    image: "/images/rooms/triple.jpg",
    features: ["Smart TV", "Western Toilet", "Geyser", "Room Service"],
    blurb:
      "Made for yatra groups of three — flexible bedding, hot water on tap and room service till late.",
  },
  {
    id: "banke-bihari-family",
    name: "Banke Bihari Family Suite",
    type: "4 Bed Deluxe Room",
    hindi: "बाँके बिहारी",
    capacity: "4+ Guests · Best for Families",
    beds: "2 King Size Beds",
    image: "/images/rooms/family.jpg",
    features: ["Air Conditioning", "Smart TV", "Attached Western Toilet", "Geyser", "Room Service"],
    blurb:
      "Two king beds under one roof — the whole parivar stays together, minutes from Banke Bihari Ji.",
  },
];

export const MENU = [
  {
    category: "Breakfast",
    items: [
      { name: "Bedmi Kachori & Aloo Sabzi", price: 80, desc: "Vrindavan's classic — spicy urad-dal kachori" },
      { name: "Aloo Paratha, Makhan & Dahi", price: 90, desc: "Tawa paratha with white butter & curd" },
      { name: "Poori Sabzi", price: 70, desc: "Fluffy pooris with seasonal aloo sabzi" },
      { name: "Poha with Sev", price: 60, desc: "Light flattened rice, coriander & lemon" },
      { name: "Kulhad Masala Chai", price: 30, desc: "Slow-brewed in an earthen kulhad" },
    ],
  },
  {
    category: "Thali & Meals",
    items: [
      { name: "Vrindavan Special Thali", price: 220, desc: "2 sabzi, dal fry, rice, 4 roti, salad, papad, sweet" },
      { name: "Dham Deluxe Thali", price: 300, desc: "Paneer, dal makhani, jeera rice, 2 naan, dessert" },
      { name: "Chole Bhature", price: 120, desc: "Amritsari chole with fluffy bhature" },
      { name: "Rajma Chawal", price: 130, desc: "Slow-cooked rajma over steamed rice" },
      { name: "Kadhi Chawal", price: 120, desc: "Tangy besan kadhi with steamed rice" },
    ],
  },
  {
    category: "Main Course",
    items: [
      { name: "Paneer Butter Masala", price: 200, desc: "Creamy tomato-makhani gravy" },
      { name: "Shahi Paneer", price: 210, desc: "Royal cashew & melon-seed gravy" },
      { name: "Malai Kofta", price: 220, desc: "Soft paneer kofte in rich gravy" },
      { name: "Dal Makhani", price: 160, desc: "Overnight-simmered black urad" },
      { name: "Dal Tadka Fry", price: 130, desc: "Ghee-tempered arhar dal" },
      { name: "Mix Veg Jhalfrezi", price: 150, desc: "Seasonal vegetables, home style" },
      { name: "Chole Masala", price: 140, desc: "Kabuli chana, anardana tang" },
      { name: "Aloo Gobhi Adraki", price: 130, desc: "Ginger-forward dry sabzi" },
    ],
  },
  {
    category: "Breads & Rice",
    items: [
      { name: "Butter Naan", price: 45, desc: "Tandoor-fresh, brushed with butter" },
      { name: "Tandoori Roti", price: 15, desc: "Whole wheat, clay-oven baked" },
      { name: "Missi Roti", price: 35, desc: "Besan & atta with ajwain" },
      { name: "Jeera Rice", price: 110, desc: "Basmati tossed in ghee-jeera" },
      { name: "Veg Pulao", price: 130, desc: "Garden vegetables, whole spices" },
      { name: "Steamed Rice", price: 90, desc: "Plain basmati" },
    ],
  },
  {
    category: "Snacks",
    items: [
      { name: "Samosa (2 pc)", price: 40, desc: "Crisp, spiced aloo filling" },
      { name: "Bread Pakora (2 pc)", price: 50, desc: "Stuffed, with green chutney" },
      { name: "Khaman Dhokla", price: 80, desc: "Steamed, airy, mustard tempering" },
      { name: "Masala Maggi", price: 70, desc: "The evergreen comfort bowl" },
    ],
  },
  {
    category: "Sweets & Drinks",
    items: [
      { name: "Gulab Jamun (2 pc)", price: 60, desc: "Warm, saffron syrup" },
      { name: "Kesar Kheer", price: 80, desc: "Slow-reduced rice kheer" },
      { name: "Rabri Kulhad", price: 90, desc: "Thick rabri, earthen kulhad" },
      { name: "Jalebi (100 g)", price: 60, desc: "Crisp, hot off the kadhai" },
      { name: "Sweet Lassi (Kulhad)", price: 80, desc: "Thick curd, malai top" },
      { name: "Badam Milk", price: 90, desc: "Warm almond & saffron milk" },
      { name: "Masala Chaas", price: 50, desc: "Spiced buttermilk, roasted jeera" },
      { name: "Filter Coffee", price: 50, desc: "South-style, frothy" },
    ],
  },
];

export const PLATFORMS = [
  {
    name: "Booking.com",
    logo: "/images/platforms/bookingdotcom.svg",
    brand: "#003A9A",
    url: "https://www.booking.com/searchresults.html?ss=Vrindavan%2C%20Uttar%20Pradesh%2C%20India",
    tag: "Genius deals",
  },
  {
    name: "MakeMyTrip",
    logo: "/images/platforms/makemytrip.svg",
    brand: "#EB2226",
    url: "https://www.makemytrip.com/hotels/vrindavan-hotels.html",
    tag: "India's favourite",
  },
  {
    name: "Goibibo",
    logo: "/images/platforms/goibibo.svg",
    brand: "#F2662D",
    url: "https://www.goibibo.com/hotels/hotels-in-vrindavan-ct/",
    tag: "goCash rewards",
  },
  {
    name: "Agoda",
    logo: "/images/platforms/agoda.svg",
    brand: "#5A2D82",
    url: "https://www.agoda.com/city/vrindavan-in.html",
    tag: "Global rates",
  },
  {
    name: "Airbnb",
    logo: "/images/platforms/airbnb.svg",
    brand: "#FF5A5F",
    url: "https://www.airbnb.co.in/s/Vrindavan--Uttar-Pradesh--India/homes",
    tag: "Homestays",
  },
];
